import { render, staticRenderFns } from "./RegulationsPage.vue?vue&type=template&id=3e09380d&scoped=true"
import script from "./RegulationsPage.vue?vue&type=script&lang=js"
export * from "./RegulationsPage.vue?vue&type=script&lang=js"
import style0 from "./RegulationsPage.vue?vue&type=style&index=0&id=3e09380d&prod&scoped=true&lang=scss"
import style1 from "./RegulationsPage.vue?vue&type=style&index=1&id=3e09380d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09380d",
  null
  
)

export default component.exports